import {inject, injectable} from "inversify";
import {YouthPlayer} from "@/modules/youth/entity";
import chance from "@/modules/base/services/chance";
import {Notifier} from "@/modules/notifications/services/Notifier";
import NotificationCreator from "@/modules/youth/notifications/NotificationCreator";
import {EventEmitter} from "@/modules/base/events";
import {BeforeYouthPlayerScoutingEvent} from "@/modules/youth/event/BeforeYouthPlayerScoutingEvent";
import {AfterYouthPlayerScoutingEvent} from "@/modules/youth/event/AfterYouthPlayerScoutingEvent";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

@injectable()
export class YouthPlayerScoutingEvaluator {
  private readonly progressRangePerAction: { min: number, max: number, fixed: number };

  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(Notifier) private notifier: Notifier,
    @inject(NotificationCreator) private notificationCreator: NotificationCreator,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
    this.progressRangePerAction = this.configRepository.get('youth.scouting.youthPlayer.progressRangePerAction');
  }

  public async evaluate(youthPlayer: YouthPlayer) {
    const incProgress = chance.floating(this.progressRangePerAction);

    console.debug(`youth player ${youthPlayer.name} total skill progress`, incProgress);

    await this.em.emitAsync(new BeforeYouthPlayerScoutingEvent(youthPlayer, incProgress));

    const revelation = Math.min(100, youthPlayer.revelation + incProgress);
    const progress = revelation - youthPlayer.revelation;

    youthPlayer.revelation = revelation;
    await youthPlayer.save();

    if (youthPlayer.revelation === 100) {
      await this.notifier.notify(
        await this.notificationCreator.createScoutingComplete(youthPlayer),
      );

      console.debug(`player '${youthPlayer.name}' fully scouted.`);
    }

    await this.em.emitAsync(new AfterYouthPlayerScoutingEvent(youthPlayer, progress));
  }
}